import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Modal from '@material-ui/core/Modal';
import { useGeneral } from '../../Context/GeneralContext';
import '../../styles/modalConfirm.css';
import { Button } from '@material-ui/core';
import { LetterX } from 'tabler-icons-react';

function getModalStyle() {
    const top = 50;
    const left = 50;

    return {
        top: `${top}%`,
        left: `${left}%`,
        transform: `translate(-${top}%, -${left}%)`,
    };
}

const useStyles = makeStyles((theme) => ({
    paper: {
        position: 'absolute',
        width: '90%',
        maxWidth: '760px',
        minWidth: '320px',
        height: 'fit-content',
        maxHeight: '90vh',
        backgroundColor: theme.palette.background.paper,
        borderRadius: 3,
        display: 'flex',
        flexDirection: 'column',
        // border: '2px solid #000',
        // boxShadow: theme.shadows[2],
        [theme.breakpoints.down('sm')]: {
            width: '95%',
            maxWidth: '100%',
        },
    },
}));

export default function ModalC() {
    const { setOpenC, openC, setConfirm } = useGeneral();
    const classes = useStyles();

    // getModalStyle is not a pure function, we roll the style only on the first render
    const [modalStyle] = React.useState(getModalStyle);

    const handleCloseAll = () => {
        setOpenC(false);
    };

    const handleClose = () => {
        setOpenC(false);
    };

    const body = (
        <div style={modalStyle} className={classes.paper}>
            <div className="modalConf-head" style={{ backgroundColor: '#FE424D' }}>
                <div className="modalConf-text" style={{ color: '#fff' }}>
                    <h4 className="modalConf-text-field">Finalizar Corrida</h4>
                </div>
                <div className="modalConf-exit">
                    <LetterX
                        size={22}
                        color={'#ffffff'}
                        onClick={handleCloseAll}
                        style={{ cursor: 'pointer' }}
                    />
                </div>
            </div>
            <div className="modalConf-body">
                <div className="modalConf-body-text">
                    <h1>Está seguro que desea finalizar la corrida?</h1>
                </div>
                <div className="modalConf-body-buttons">
                    <div className="modalConf-body-buttons-first">
                        <Button
                            className="modalM-body-buttonS"
                            style={{ backgroundColor: '#FE424D' }}
                            onClick={(e) => {
                                handleClose();
                                setConfirm(true);
                            }}
                        >
                            <h1 style={{ color: '#fff' }}>Confirmar</h1>
                        </Button>
                    </div>

                    <div className="modalConf-body-buttons-second">
                        <Button
                            className="modalM-body-buttonC"
                            style={{
                                borderRadius: '3px',
                                borderWidth: '2px',
                                borderStyle: 'solid',
                                borderColor: '#FE424D',
                            }}
                            onClick={(e) => handleClose()}
                        >
                            <h1>Cancelar</h1>
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    );

    return (
        <div>
            <Modal
                open={openC}
                onClose={handleClose}
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
            >
                {body}
            </Modal>
        </div>
    );
}
